(() => {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pp-faq-button]');
    if (!button) return;

    const item = button.closest('[data-pp-faq-item]');
    if (!item) return;

    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    item.classList.toggle('is-open', !expanded);

    const icon = button.querySelector('[data-pp-faq-icon]');
    if (icon) icon.textContent = expanded ? '+' : '-';
  });

  if (!prefersReduced) {
    const counters = document.querySelectorAll('[data-pp-countup]');
    const runCounter = (element) => {
      if (element.dataset.ppCounted === 'true') return;
      element.dataset.ppCounted = 'true';
      const finalText = element.textContent.trim();
      const target = Number(String(element.dataset.ppCountup).replace(',', '.'));
      const decimals = finalText.includes(',') || finalText.includes('.') ? 1 : 0;
      if (!Number.isFinite(target)) return;

      const start = performance.now();
      const duration = 1500;

      const tick = (now) => {
        const progress = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);
        const value = target * eased;
        element.textContent = value.toFixed(decimals).replace('.', ',');

        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          element.textContent = finalText;
        }
      };

      element.textContent = decimals ? '0,0' : '0';
      requestAnimationFrame(tick);
    };

    if ('IntersectionObserver' in window && counters.length) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            runCounter(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.35 });
      counters.forEach((counter) => observer.observe(counter));
    } else {
      counters.forEach(runCounter);
    }
  }

  /* Dzwiek w kafelkach UGC. Wlaczony na jednym kafelku wycisza pozostale —
     dwa filmy grajace naraz to halas, nie funkcja. */
  const ustawDzwiek = (button, wlaczony) => {
    button.setAttribute('aria-pressed', String(wlaczony));
    button.setAttribute('aria-label', wlaczony ? 'Wycisz' : 'Włącz dźwięk');
  };

  /* Wideo w kafelkach UGC gra tylko wtedy, gdy jest na ekranie. */
  const ugcVideos = document.querySelectorAll('[data-pp-ugc-video] video');
  if (ugcVideos.length) {
    ugcVideos.forEach((video) => {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', 'playsinline');
    });

    if ('IntersectionObserver' in window && !prefersReduced) {
      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              const played = video.play();
              if (played && typeof played.catch === 'function') played.catch(() => {});
            } else {
              video.pause();
              video.muted = true;
              const przycisk = video.closest('.pp-ugc-card')?.querySelector('[data-pp-ugc-sound]');
              if (przycisk) ustawDzwiek(przycisk, false);
            }
          });
        },
        { threshold: 0.4 }
      );
      ugcVideos.forEach((video) => videoObserver.observe(video));
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pp-ugc-sound]');
    if (!button) return;

    event.preventDefault();
    const card = button.closest('.pp-ugc-card');
    const video = card && card.querySelector('video');
    if (!video) return;

    const wlaczamy = button.getAttribute('aria-pressed') !== 'true';

    document.querySelectorAll('[data-pp-ugc-sound]').forEach((inny) => {
      if (inny === button) return;
      const innaKarta = inny.closest('.pp-ugc-card');
      const inneWideo = innaKarta && innaKarta.querySelector('video');
      if (inneWideo) inneWideo.muted = true;
      ustawDzwiek(inny, false);
    });

    video.muted = !wlaczamy;
    ustawDzwiek(button, wlaczamy);

    if (wlaczamy) {
      const played = video.play();
      if (played && typeof played.catch === 'function') played.catch(() => {});
    }
  });

  /* Plusik na kafelku bestsellera: dodaje do koszyka, kafelek dalej prowadzi na karte. */
  const quickAddConfig = () => {
    if (typeof fetchConfig === 'function') return fetchConfig('javascript');
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
    };
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pp-quick-add]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = Number(button.dataset.ppVariant);
    if (!Number.isFinite(variantId) || button.getAttribute('aria-busy') === 'true') return;

    const label = button.querySelector('span');
    // Ten sam handler obsluguje plusik na kafelku i przycisk "Dodaj zestaw do
    // koszyka" w pp-bundle-feature. Po potwierdzeniu wracamy do tekstu, ktory
    // byl na przycisku, a nie zawsze do "+".
    const labelText = label ? label.textContent : '';
    const doneText = labelText.trim() === '+' ? '✓' : 'Dodano ✓';
    const drawer = document.querySelector('cart-drawer');
    button.setAttribute('aria-busy', 'true');

    const config = quickAddConfig();
    config.body = JSON.stringify({
      items: [{ id: variantId, quantity: 1 }],
      sections: drawer ? ['cart-drawer', 'cart-icon-bubble'] : [],
      sections_url: window.location.pathname,
    });

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', config)
      .then((response) => response.json())
      .then((json) => {
        if (json.status) throw new Error(json.description || json.message);
        button.removeAttribute('aria-busy');
        if (drawer && json.sections) {
          drawer.renderContents(json);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        button.classList.add('is-done');
        if (label) label.textContent = doneText;
        setTimeout(() => {
          button.classList.remove('is-done');
          if (label) label.textContent = labelText;
        }, 1800);
      })
      .catch((error) => {
        console.error('[pp-home] nie udalo sie dodac do koszyka', error);
        button.removeAttribute('aria-busy');
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      });
  });

  const stickyBars = document.querySelectorAll('[data-pp-sticky-bar]');
  if (stickyBars.length) {
    const updateSticky = () => {
      stickyBars.forEach((bar) => {
        const threshold = Number(bar.dataset.threshold || 560);
        bar.classList.toggle('is-visible', window.scrollY > threshold);
      });
    };

    updateSticky();
    window.addEventListener('scroll', updateSticky, { passive: true });
  }
})();
